/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteCookiesQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteCookiesQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly cookies: ReadonlyArray<{ readonly __typename?: 'WebsiteFetchingSettingsCookie', readonly name: string, readonly value: string }> } | null };


export const WebsiteCookiesDocument = gql`
    query WebsiteCookies($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    cookies {
      name
      value
    }
    id
  }
}
    `;

/**
 * __useWebsiteCookiesQuery__
 *
 * To run a query within a React component, call `useWebsiteCookiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteCookiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteCookiesQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteCookiesQuery(baseOptions: Apollo.QueryHookOptions<WebsiteCookiesQuery, WebsiteCookiesQueryVariables> & ({ variables: WebsiteCookiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteCookiesQuery, WebsiteCookiesQueryVariables>(WebsiteCookiesDocument, options);
      }
export function useWebsiteCookiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteCookiesQuery, WebsiteCookiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteCookiesQuery, WebsiteCookiesQueryVariables>(WebsiteCookiesDocument, options);
        }
export function useWebsiteCookiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteCookiesQuery, WebsiteCookiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteCookiesQuery, WebsiteCookiesQueryVariables>(WebsiteCookiesDocument, options);
        }
export type WebsiteCookiesQueryHookResult = ReturnType<typeof useWebsiteCookiesQuery>;
export type WebsiteCookiesLazyQueryHookResult = ReturnType<typeof useWebsiteCookiesLazyQuery>;
export type WebsiteCookiesSuspenseQueryHookResult = ReturnType<typeof useWebsiteCookiesSuspenseQuery>;
export type WebsiteCookiesQueryResult = Apollo.QueryResult<WebsiteCookiesQuery, WebsiteCookiesQueryVariables>;